import { createAction, props } from '@ngrx/store';
import { Holder, HolderForm } from '../../models/holder.model';
import { PaginationState } from '../../models/stock.model';

// Load Holders
export const loadHolders = createAction(
  '[Holders] Load Holders',
  props<{ stockId?: string; filters?: { pageNumber?: number; pageSize?: number } }>()
);
export const loadHoldersSuccess = createAction(
  '[Holders] Load Holders Success',
  props<{ holders: Holder[]; pagination: PaginationState }>()
);
export const loadHoldersFailure = createAction(
  '[Holders] Load Holders Failure',
  props<{ error: any }>()
);

// Load Single Holder
export const loadHolder = createAction('[Holders] Load Holder', props<{ id: string }>());
export const loadHolderSuccess = createAction(
  '[Holders] Load Holder Success',
  props<{ holder: Holder }>()
);
export const loadHolderFailure = createAction(
  '[Holders] Load Holder Failure',
  props<{ error: any }>()
);

// Create Holder
export const createHolder = createAction(
  '[Holders] Create Holder',
  props<{ holder: HolderForm }>()
);
export const createHolderSuccess = createAction(
  '[Holders] Create Holder Success',
  props<{ holder: Holder }>()
);
export const createHolderFailure = createAction(
  '[Holders] Create Holder Failure',
  props<{ error: any }>()
);

// Update Holder
export const updateHolder = createAction(
  '[Holders] Update Holder',
  props<{ id: string; holder: HolderForm }>()
);
export const updateHolderSuccess = createAction(
  '[Holders] Update Holder Success',
  props<{ holder: Holder }>()
);
export const updateHolderFailure = createAction(
  '[Holders] Update Holder Failure',
  props<{ error: any }>()
);

// Delete Holder
export const deleteHolder = createAction('[Holders] Delete Holder', props<{ id: string }>());
export const deleteHolderSuccess = createAction(
  '[Holders] Delete Holder Success',
  props<{ id: string }>()
);
export const deleteHolderFailure = createAction(
  '[Holders] Delete Holder Failure',
  props<{ error: any }>()
);
